import { Component } from '@theme/component';

/**
 * Selling-plan (subscription) selector.
 *
 * Renders one-time vs subscribe radio cards. On change it writes the chosen
 * selling-plan id into the product form's hidden `selling_plan` input (empty =
 * one-time) so add-to-cart submits the right purchase option, and updates the
 * displayed price from the selected card/option's formatted `data-price`.
 *
 * @extends {Component}
 */
class SellingPlans extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#sync);
    this.#sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#sync);
  }

  #sync = () => {
    const checked = this.querySelector('.selling-plans__radio:checked');
    if (!(checked instanceof HTMLInputElement)) return;

    let sellingPlan = '';
    let price = checked.dataset.price;

    if (checked.value === 'subscribe') {
      const select = checked.closest('.selling-plans__card')?.querySelector('.selling-plans__select');
      if (select instanceof HTMLSelectElement) {
        sellingPlan = select.value;
        price = select.selectedOptions[0]?.dataset.price ?? price;
      }
    }

    this.#setSellingPlan(sellingPlan);
    if (price) this.#setPrice(price);
  };

  /** @returns {ParentNode} the section root (falls back to document) */
  #scope() {
    const id = this.dataset.sectionId;
    return (id && document.getElementById(`shopify-section-${id}`)) || document;
  }

  /** @param {string} value */
  #setSellingPlan(value) {
    const input = this.#scope().querySelector('input[name="selling_plan"]');
    if (input instanceof HTMLInputElement) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /** @param {string} formatted */
  #setPrice(formatted) {
    const container = this.#scope().querySelector('product-price [ref="priceContainer"]');
    if (container) container.textContent = formatted;
  }
}

if (!customElements.get('selling-plans')) {
  customElements.define('selling-plans', SellingPlans);
}
